// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1stc_","name":"styles_name__2E2oH","phone":"styles_phone__3CgKW"};